import { SimilarListing } from './listing';

export interface ExclusiveListingInfo {
  created_at?: string | null;
  display_address_human_readable?: string;
  display_street_name?: string;
  end_time?: string | null;
  exclusives_listing_price_cents?: number | null;
  local_area_map_image?: string;
  max_coe_date?: string;
  mls_listing_price_cents?: number | null;
  ongoing_and_upcoming_open_houses?: OpenHouse[];
  reservation_customer_uuid?: string | null;
  reservation_end_time?: string | null;
  reservation_locked?: boolean;
  similar_listings?: SimilarListing[];
  start_time?: string | null;
  seller_offer_experiment?: boolean;
  state: ExclusiveListingState;
  previous_listing_photos_opt_out?: boolean | null;
  seller_disclosures_download_url?: string;
  zillow_url?: string | null;
  ballpark_price_range?: {
    low_estimate_cents: number;
    high_estimate_cents: number;
  } | null;
  prior_listing_photo_data?: PriorListingPhotoData | null;
  /**
   * @deprecated
   */
  display_slug?: string;
}

export interface PriorListingPhotoData {
  urls: string[];
  listed_at?: string | null;
}

export interface OpenHouse {
  start_time: string;
  end_time: string;
  uuid: string;
}

export const ExclusiveListingState = {
  Listed: 'el_listed',
  InContract: 'el_in_contract',
  Sold: 'el_sold',
  Setup: 'el_setup',
  Expired: 'el_expired',
  AwaitingSellerCommitment: 'el_awaiting_seller_commitment',
} as const;

export type ExclusiveListingState =
  (typeof ExclusiveListingState)[keyof typeof ExclusiveListingState];
